import React from 'react';
import './BottomModal.css';

interface BottomModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;

  actionLabel?: string;
  onAction?: () => void;

  /** 상단 X 버튼 노출 여부 (기본 노출) */
  showCloseButton?: boolean;
}

const BottomModal: React.FC<BottomModalProps> = ({isOpen, onClose, children, actionLabel, onAction, showCloseButton = true }) => {
  if (!isOpen) return null;

  const showActionButton = Boolean(actionLabel && onAction);

  return (
    <div className={"modalOverlay"} onClick={onClose}>
      <div className={"bottomModal"} onClick={(e) => e.stopPropagation()}>
        {showCloseButton && (
          <button className={'modalCloseButton'} onClick={onClose}>
            <img src={'/assets/images/ico/ic_close_24.png'} alt={'Close Button'} />
          </button>
        )}

        <div className={'modalContent'}>
          {children}
        </div>

        {showActionButton && (
          <div className="btnArea modalActionButtonOverlay">
            <button className={'btnPrimaryTy01 modalActionButton'} onClick={onAction}>
              {actionLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default BottomModal;